var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    width: "100%",
    height: 80,
    viewBox: "0 0 262 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6667 0H13.3333C5.96954 0 0 5.96954 0 13.3333V66.6667C0 74.0305 5.96954 80 13.3333 80H66.6667C74.0305 80 80 74.0305 80 66.6667V13.3333C80 5.96954 74.0305 0 66.6667 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.315 52.1502C44.0505 54.3404 44.8009 57.141 46.9911 58.4055C49.1813 59.67 51.9819 58.9196 53.2464 56.7294L63.4297 39.0913C64.6942 36.9011 63.9438 34.1006 61.7536 32.8361C59.5634 31.5716 56.7629 32.322 55.4984 34.5122L45.315 52.1502Z",
    fill: "#7AAFFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0908 34.1835C22.8263 31.9933 20.0257 31.2429 17.8355 32.5074C15.6454 33.7719 14.895 36.5725 16.1595 38.7627L26.1365 56.0435C27.401 58.2337 30.2016 58.9841 32.3918 57.7196C34.582 56.4551 35.3324 53.6545 34.0679 51.4643L24.0908 34.1835Z",
    fill: "#468CFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9578 56.8669C46.2637 59.1288 49.1552 59.9042 51.4162 58.5989C53.6771 57.2935 54.4513 54.4017 53.1454 52.1398L43.6683 35.725C42.3624 33.4631 39.4709 32.6876 37.2099 33.9929C34.949 35.2983 34.1748 38.1901 35.4807 40.4521L44.9578 56.8669Z",
    fill: "#39FFF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7366 40.4156C45.0425 38.1536 44.2683 35.2618 42.0074 33.9564C39.7465 32.6511 36.855 33.4265 35.5491 35.6885L26.2824 51.7388C24.9765 54.0007 25.7507 56.8926 28.0116 58.1979C30.2725 59.5033 33.164 58.7278 34.4699 56.4659L43.7366 40.4156Z",
    fill: "#94B8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4375 29.5726C67.8492 29.5726 69.8042 27.6175 69.8042 25.2059C69.8042 22.7943 67.8492 20.8392 65.4375 20.8392C63.0259 20.8392 61.0709 22.7943 61.0709 25.2059C61.0709 27.6175 63.0259 29.5726 65.4375 29.5726Z",
    fill: "url(#paint0_linear_106_216)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "wad",
    d: "M159.509 22.504L150.359 57.604H140.009L134.409 34.504L128.609 57.604H118.259L109.359 22.504H118.509L123.559 48.054L129.809 22.504H139.209L145.209 48.054L150.309 22.504H159.509ZM185.647 51.404H172.547L170.447 57.604H161.497L174.197 22.504H184.097L196.797 57.604H187.747L185.647 51.404ZM183.447 44.804L179.097 31.954L174.797 44.804H183.447ZM213.813 22.504C217.513 22.504 220.746 23.2373 223.513 24.704C226.279 26.1707 228.413 28.2373 229.913 30.904C231.446 33.5373 232.213 36.5873 232.213 40.054C232.213 43.4873 231.446 46.5373 229.913 49.204C228.413 51.8707 226.263 53.9373 223.463 55.404C220.696 56.8707 217.479 57.604 213.813 57.604H200.663V22.504H213.813ZM213.263 50.204C216.496 50.204 219.013 49.3207 220.813 47.554C222.613 45.7873 223.513 43.2873 223.513 40.054C223.513 36.8207 222.613 34.304 220.813 32.504C219.013 30.704 216.496 29.804 213.263 29.804H209.213V50.204H213.263Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_216",
    x1: 61.5417,
    y1: 27.1809,
    x2: 69.3334,
    y2: 23.2309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#7FFFD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#80FADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#8FCAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B8FF"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@media screen and (max-width: 768px) {\n    #logo {\n        width: 200px;\n    }\n    #wad{\n       display: none;\n       width: 0;\n    }\n\n}\n")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.70292a1a413a5d73c13645bd90f87c07.svg";
export { ForwardRef as ReactComponent };